import { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";

import { Box } from "@mui/material";

interface BaseLayoutProps {
  children?: ReactNode;
}

/**
 * FB-8: this layout used to fetch the signed-in user's menstruation phase on
 * every render and pop the `VerifyPeriod` confirmation on top of any page —
 * client-only behaviour that also ran (and 404'd) for staff roles. The client
 * surface moved to the mobile app, so the layout is now just the page shell.
 */
const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        height: "100%",
      }}
    >
      {children || <Outlet />}
    </Box>
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node,
};

export default BaseLayout;
